/* HEARTBOOK popup thu email (07/10/2026). Nguồn + nghiên cứu: HQ-Groups brands/heartbook/store/popup-2026-10-07/DE_XUAT.md.
   - Chia nhóm theo trình duyệt (cookie hb_pp_arm, 60 ngày): A thấy popup, H không bao giờ thấy (tỷ lệ H = "holdout" trong section).
     Nhóm ghi vào giỏ (cart attribute _hb_pp) ngay khi giỏ có hàng, để mọi đơn mang nhãn nhóm. Chỉ 1 request, chỉ với khách có giỏ.
   - Hiện khi khách LƯỚT NGƯỢC lên nhanh (sắp rời trang) / chuột rời mép trên (máy tính), HOẶC sau delaySeconds giây trên trang (founder 07/10:
     "điều kiện nào đến trước hiện trước"); tối thiểu minSeconds trên trang. ?hb_pp_t=<giây> ghi đè hẹn giờ (máy kiểm; 0 = tắt).
   - Không hiện: nhóm H, giỏ có hàng / vừa thêm giỏ, trang giỏ & tài khoản (section báo skip), khách đến từ email, đã đăng ký, đã đóng trong dismissDays,
     đang mở ngăn kéo / bảng khác, ngay sau một cú bấm (cuộn do bấm nút, không phải khách lướt).
   - Gửi email thẳng cổng client/subscriptions của Klaviyo (public key, không nạp klaviyo.js), vào list "Popup leads".
   - Đăng ký xong: áp mã ngầm; khi giỏ có cuốn sách đầu tiên thì tự thêm 1 túi quà (mã trừ túi khi có sách), 1 lần duy nhất.
   - Đo bằng Clarity (gửi chung lô sẵn có, không thêm request): tag hb_pp_arm, event hb_pp_show / hb_pp_submit / hb_pp_close / hb_pp_bag_added /
     hb_pp_teaser_show / hb_pp_teaser_open / hb_pp_teaser_close.
   - Đóng popup thì còn nút nhắc nhỏ góc dưới trái (founder 07/10), bấm là mở lại.
   - Máy kiểm / người kiểm: thêm ?hb_pp=A hoặc ?hb_pp=H để ép nhóm; ?hb_pp_reset=1 để xoá dấu đã đóng / đã đăng ký (chỉ dùng khi kiểm). Nạp async, không chờ main.js của Shrine. */
(() => {
  if (window.__hbPP) return;
  window.__hbPP = true;
  const cfgEl = document.getElementById('hb-pp-config');
  const tpl = document.getElementById('hb-pp-tpl');
  if (!cfgEl || !tpl) return;
  let C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  const DAY = 864e5;
  const getCookie = (k) => (document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')) || [])[1] || '';
  const setCookie = (k, v, days) => { document.cookie = `${k}=${v}; path=/; max-age=${Math.round(days * 86400)}; SameSite=Lax`; };
  const ss = { get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} } };
  const clarity = (...a) => {
    try {
      if (typeof window.clarity !== 'function') window.clarity = function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      window.clarity(...a);
    } catch (e) {}
  };

  // người kiểm lỡ đóng / đã gửi: thêm ?hb_pp_reset=1 để xoá dấu đã đóng + đã đăng ký + dấu khách đến từ email (founder 07/10)
  if (/[?&]hb_pp_reset=1(?:&|$)/.test(location.search)) {
    ['hb_pp_closed', 'hb_pp_sub'].forEach((k) => { document.cookie = `${k}=; path=/; max-age=0; SameSite=Lax`; });
    try { sessionStorage.removeItem('hb_pp_email'); } catch (e) {}
  }

  // ---------- nhóm A / H ----------
  const forced = (location.search.match(/[?&]hb_pp=(A|H)(?:&|$)/) || [])[1];
  // founder 07/10 "hiện cả đi, ko cần rollout 50% nữa": holdout = 0 thì MỌI người là A, kể cả người đã bị chia H trước đó (cookie 60 ngày)
  const holdout = Number(C.holdout || 0);
  let arm = forced || (holdout > 0 ? getCookie('hb_pp_arm') : 'A');
  if (arm !== 'A' && arm !== 'H') arm = Math.random() * 100 < holdout ? 'H' : 'A';
  setCookie('hb_pp_arm', arm, 60);
  clarity('set', 'hb_pp_arm', arm);

  // ---------- ghi nhóm vào giỏ ----------
  let hasCart = Number(C.cartCount || 0) > 0;
  let tagged = C.cartArm === arm;
  let tries = 0;
  // Ghi nhãn rồi 3 giây sau đọc lại giỏ: lệnh giỏ khác chạy cùng lúc (áp mã /discount, thêm túi) có thể ghi đè mất thuộc tính
  // (máy kiểm 07/10 bắt được trên điện thoại: giỏ có túi $0 nhưng attributes rỗng). Tối đa 3 lần.
  const tagCart = () => {
    if (tagged || tries >= 3) return;
    tagged = true;
    tries++;
    const retry = () => { tagged = false; setTimeout(tagCart, 3000 * tries); };
    fetch(`${C.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _hb_pp: arm } }),
      keepalive: true,
    }).then((r) => {
      if (!r.ok) return retry();
      setTimeout(() => {
        fetch(`${C.root}cart.js`, { headers: { Accept: 'application/json' } })
          .then((x) => x.json())
          .then((c) => { if ((c.attributes || {})._hb_pp !== arm && (c.item_count || 0) > 0) retry(); })
          .catch(() => {});
      }, 3000);
    }).catch(retry);
  };
  // thêm túi (áp mã + /cart/add) xong mới ghi nhãn, tránh hai lệnh giỏ đè nhau
  // đường dự phòng (thấy request /cart/add mà không có tín hiệu theme, ví dụ Shrine chưa nạp): đọc giỏ rồi mới thêm túi
  const onCart = () => {
    hasCart = true;
    setTimeout(async () => {
      if (Date.now() - viaEvent < 2000) return tagCart();
      try {
        const cart = await (await fetch(`${C.root}cart.js`, { headers: { Accept: 'application/json' } })).json();
        learn(cart);
        await maybeAddBag(true);
        await maybeReapply(cart);
      } catch (e) {}
      tagCart();
    }, 800);
  };
  if (hasCart) (window.requestIdleCallback || setTimeout)(() => { Promise.resolve(maybeAddBag(true)).finally(tagCart); });
  // mọi lệnh thêm giỏ của mọi nút (Shrine, Quick add, mua kèm, thanh dính) đều là request /cart/add: nghe thụ động, không bọc fetch
  try {
    new PerformanceObserver((list) => {
      if (list.getEntries().some((e) => /\/cart\/add(\.js)?(\?|$)/.test(e.name))) onCart();
    }).observe({ type: 'resource', buffered: false });
  } catch (e) {}
  // form thêm giỏ gửi kiểu thường (Shrine chưa nạp): trang sẽ sang /cart, ở đó section báo cartCount > 0 và ghi nhóm
  window.addEventListener('submit', (e) => {
    const f = e.target;
    if (f && /\/cart\/add/.test(f.getAttribute('action') || '')) hasCart = true;
  }, true);

  // ---------- túi quà tự vào giỏ (founder 07/10: giỏ trống mà bấm "thêm túi" thì túi hiện $4.95, khách tưởng "free" là nói dối) ----------
  // Mã WELCOMEBAG chỉ trừ túi khi giỏ có sách. Nên: đăng ký xong thì áp mã ngầm + ghi hb_pp_bag=pending; khi giỏ có cuốn sách đầu tiên,
  // tự thêm 1 túi (giỏ hiện sách + túi $0). Thêm 1 lần duy nhất (done), khách xoá túi thì không thêm lại.
  // Link trong mail chào mừng có ?hb_pp_bag=1: mở trên máy khác vẫn được tự thêm túi.
  // Founder 07/10 "thêm giỏ một lúc sau phong bì mới hiện": bản đầu chạy nối đuôi đọc giỏ + áp mã (2 lượt) + thêm túi = 2–3 giây trên điện thoại.
  // Giờ: biết giỏ từ tín hiệu cartUpdate của theme (kèm món vừa thêm) + giỏ lúc tải trang (Liquid); mã áp lúc đăng ký (cookie discount_code);
  // còn đúng 1 lệnh thêm túi, gửi ngay khi sách vào giỏ. Đường cũ (đọc /cart.js) chỉ còn làm dự phòng khi không có tín hiệu theme.
  const BOOK_TYPES = (C.bookTypes || []).map((t) => String(t).trim().toLowerCase()).filter(Boolean);
  const isBook = (i) => BOOK_TYPES.includes(String((i && i.product_type) || '').toLowerCase());
  const inCart = new Set((C.cartVariants || []).map(Number));
  let bookInCart = (C.cartTypes || []).some((t) => BOOK_TYPES.includes(String(t || '').toLowerCase()));
  function applyCode() {
    if (getCookie('discount_code') === C.code) return Promise.resolve();
    return fetch(`${C.root}discount/${encodeURIComponent(C.code)}?redirect=${encodeURIComponent(C.root + 'cart.js')}`, { credentials: 'same-origin' }).catch(() => {});
  }
  if (/[?&]hb_pp_bag=1(?:&|$)/.test(location.search) && getCookie('hb_pp_bag') !== 'done') setCookie('hb_pp_bag', 'pending', 30);
  // học giỏ: cả giỏ (/cart.js, đổi số lượng trong ngăn giỏ) thì làm lại từ đầu; một món (/cart/add.js) thì cộng thêm
  function learn(d) {
    if (!d) return;
    if (Array.isArray(d.items) && d.item_count != null) {
      inCart.clear();
      bookInCart = false;
    }
    (Array.isArray(d.items) ? d.items : [d]).forEach((i) => {
      if (!i || !i.variant_id) return;
      inCart.add(Number(i.variant_id));
      if (isBook(i)) bookInCart = true;
    });
  }
  let bagBusy = false;
  async function maybeAddBag(knowCart) {
    if (bagBusy || getCookie('hb_pp_bag') !== 'pending' || !C.bagVariant || !C.bagAvailable) return;
    if (!knowCart) {
      try { learn(await (await fetch(`${C.root}cart.js`, { headers: { Accept: 'application/json' } })).json()); } catch (e) { return; }
    }
    if (inCart.has(Number(C.bagVariant))) { setCookie('hb_pp_bag', 'done', 30); return; }
    if (!bookInCart) return; // chưa có sách: chờ lần thêm giỏ sau
    bagBusy = true;
    setCookie('hb_pp_bag', 'done', 30); // ghi trước khi thêm: chính lệnh thêm túi cũng là lệnh giỏ, không được tự gọi lại
    try {
      // MỘT lệnh /cart/update.js (Shopify hỗ trợ discount từ 05/2025): thêm túi + áp mã vào GIỎ + ghi nhãn nhóm + lấy bản vẽ ngăn giỏ.
      // Án lệ 07/10: áp mã lúc giỏ còn trống chỉ lưu cookie cho checkout, ngăn giỏ vẫn hiện túi $4.95; tách thành nhiều lệnh thì đè mất nhãn.
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map((x) => x.id) : ['cart-icon-bubble'];
      const res = await fetch(`${C.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: { [Number(C.bagVariant)]: 1 }, discount: C.code, attributes: { _hb_pp: arm }, sections, sections_url: location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) { setCookie('hb_pp_bag', 'pending', 30); return; }
      inCart.add(Number(C.bagVariant));
      tagged = true; // nhãn nhóm đã ghi trong cùng lệnh
      clarity('event', 'hb_pp_bag_added');
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && drawer && typeof drawer.renderContents === 'function' && data.sections) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hb-popup', productVariantId: Number(C.bagVariant), cartData: data });
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      }
    } catch (e) {
      setCookie('hb_pp_bag', 'pending', 30);
    } finally { bagBusy = false; }
  }
  // Founder 07/10: "xoá phong bì khỏi giỏ rồi thêm lại thì không free nữa". Xoá túi thì Shopify bỏ luôn mã khỏi giỏ (hết món để giảm);
  // thêm túi lại (thanh dính, mua kèm, gợi ý trong giỏ...) thì túi $4.95. Người đã đăng ký mà giỏ có túi và mã chưa áp -> áp lại mã.
  let reapplyBusy = false;
  async function maybeReapply(d) {
    if (reapplyBusy || !d || !C.bagVariant) return;
    if (getCookie('hb_pp_sub') !== '1' && getCookie('hb_pp_bag') !== 'done') return;
    if (!inCart.has(Number(C.bagVariant)) || !bookInCart) return; // mã chỉ có nghĩa khi giỏ có túi; không có sách thì giỏ chỉ có túi lẻ
    const full = Array.isArray(d.items) && d.item_count != null;
    const bag = Number(C.bagVariant);
    if (full) {
      const on = (d.discount_codes || []).some((x) => String(x.code || '').toUpperCase() === String(C.code).toUpperCase() && x.applicable);
      if (on) return;
    } else {
      const added = (Array.isArray(d.items) ? d.items : [d]).some((i) => i && Number(i.variant_id) === bag);
      if (!added) return; // vừa thêm món khác, không phải túi: mã (nếu có) vẫn nằm trong giỏ
    }
    reapplyBusy = true;
    try {
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map((x) => x.id) : ['cart-icon-bubble'];
      const res = await fetch(`${C.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ discount: C.code, sections, sections_url: location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) return;
      clarity('event', 'hb_pp_code_reapplied');
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && drawer && typeof drawer.renderContents === 'function' && data.sections) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hb-popup', productVariantId: bag, cartData: data });
        drawer.renderContents(data);
      }
    } catch (e) {} finally { reapplyBusy = false; }
  }

  // tín hiệu "đã thêm giỏ" của theme (nút mua Shrine, thanh dính, Quick add, mua kèm, ngăn giỏ) kèm món vừa thêm: đường nhanh
  let viaEvent = 0;
  const onThemeCart = (ev) => {
    if (!ev || ev.source === 'hb-popup') return;
    viaEvent = Date.now();
    learn(ev.cartData);
    hasCart = true;
    Promise.resolve(maybeAddBag(true)).then(() => maybeReapply(ev.cartData)).finally(tagCart);
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, onThemeCart);
  else document.addEventListener('DOMContentLoaded', () => { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, onThemeCart); });

  if (C.skip || arm !== 'A') return;

  // ---------- ai không thấy ----------
  const q = location.search;
  if (/[?&](_kx|utm_medium=email)|utm_source=[^&]*klaviyo/i.test(q)) ss.set('hb_pp_email', '1');
  if (ss.get('hb_pp_email') === '1') return;
  if (getCookie('hb_pp_sub') === '1') return;
  const closedAt = Number(getCookie('hb_pp_closed') || 0);
  // đã đóng trong dismissDays: không TỰ hiện nữa, nhưng còn nút nhắc nhỏ để khách tự mở lại (founder 07/10: "khách bỏ qua là mất cơ hội luôn à")
  const closedRecently = !!(closedAt && Date.now() - closedAt < Number(C.dismissDays || 7) * DAY);

  const t0 = Date.now();
  let shown = closedRecently;
  let lastClick = 0;
  document.addEventListener('click', () => { lastClick = Date.now(); }, { capture: true, passive: true });
  const busy = () =>
    !!document.querySelector('cart-drawer.active, .drawer.active, .hb-qa:not([hidden]), .hb-qv[open], details[open] > .menu-drawer, .popup-modal--active') ||
    document.body.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden-mobile');
  const ready = () => !shown && !hasCart && Date.now() - t0 >= Number(C.minSeconds || 0) * 1000 && Date.now() - lastClick > 900 && !document.hidden && !busy();

  // ---------- dấu hiệu sắp rời trang ----------
  // Một "cú lướt ngược" = chuỗi sự kiện cuộn đi LÊN liên tiếp. Tính quãng và thời gian từ sự kiện đầu của chuỗi (không từ vị trí đứng yên
  // trước đó: sau khi đọc yên một lúc, sự kiện đầu tiên của cú lướt đã lệch vài chục px). Đổi chiều xuống là xoá chuỗi.
  let maxY = window.scrollY;
  let lastY = window.scrollY;
  let runPx = 0;
  let runT0 = 0;
  const UP_PX = 200; // lướt ngược ít nhất 200px
  const UP_MS = 350; // trong vòng 0,35 giây, chỉnh ở đây nếu số đo cho thấy quá nhạy / quá lì
  const DEEP_PX = 400; // phải từng cuộn xuống ít nhất 400px
  const onScroll = () => {
    const y = window.scrollY;
    const now = performance.now();
    if (y > maxY) maxY = y;
    if (y < lastY) {
      if (!runPx || now - runT0 > UP_MS) { runPx = 0; runT0 = now; }
      runPx += lastY - y;
    } else if (y > lastY) runPx = 0;
    lastY = y;
    if (maxY >= DEEP_PX && runPx >= UP_PX && now - runT0 <= UP_MS && ready()) open('scroll_up');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  // hẹn giờ: đủ delaySeconds thì hiện; lúc đó chưa hợp lệ (đang mở ngăn giỏ, vừa bấm, tab ẩn...) thì thử lại mỗi 2 giây.
  // Giỏ có hàng / đã hiện thì thôi hẳn.
  const forcedT = (location.search.match(/[?&]hb_pp_t=(\d+)(?:&|$)/) || [])[1];
  const delayS = forcedT != null ? Number(forcedT) : Number(C.delaySeconds || 0);
  if (delayS > 0) {
    const tick = () => {
      if (shown || hasCart) return;
      if (ready()) open('timer');
      else setTimeout(tick, 2000);
    };
    setTimeout(tick, delayS * 1000);
  }
  document.addEventListener('mouseout', (e) => {
    if (!e.relatedTarget && e.clientY <= 0 && window.innerWidth >= 750 && ready()) open('exit_top');
  });

  // ---------- popup ----------
  let root;
  let prevOverflow = '';
  function open(trigger) {
    shown = true;
    window.removeEventListener('scroll', onScroll);
    document.body.appendChild(tpl.content.cloneNode(true));
    root = document.querySelector('[data-hb-pp]');
    if (!root) return;
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-open')));
    root.querySelector('.hb-pp__card').setAttribute('tabindex', '-1');
    root.querySelector('.hb-pp__card').focus({ preventScroll: true });
    clarity('set', 'hb_pp_trigger', trigger);
    clarity('event', 'hb_pp_show');
    root.addEventListener('click', onClick);
    root.querySelector('[data-hb-pp-form]').addEventListener('submit', onSubmit);
    document.addEventListener('keydown', onKey);
  }
  function close(how) {
    if (!root) return;
    if (how !== 'done') {
      setCookie('hb_pp_closed', String(Date.now()), Number(C.dismissDays || 7));
      clarity('event', 'hb_pp_close');
      setTimeout(showTeaser, 400);
    } else hideTeaser();
    document.removeEventListener('keydown', onKey);
    root.classList.remove('is-open');
    document.documentElement.style.overflow = prevOverflow;
    const r = root;
    root = null;
    setTimeout(() => r.remove(), 300);
  }
  const onKey = (e) => { if (e.key === 'Escape') close(); };
  function onClick(e) {
    if (e.target.closest('[data-hb-pp-close]')) return close(root && root.dataset.step === 'ok' ? 'done' : '');
    if (e.target.closest('[data-hb-pp-copy]')) return copyCode(e.target.closest('[data-hb-pp-copy]'));
  }

  // ---------- nút nhắc (teaser) ----------
  // Sau khi khách ĐÓNG popup (không phải sau khi đăng ký): viên nhỏ góc dưới trái "Free gift bag", bấm là mở lại đúng popup.
  // Né thanh mua dính (đứng ngay trên nó). Dấu × nhỏ ẩn tới hết phiên. Không hiện ở nhóm H, trang giỏ/tài khoản, khách từ email, người đã đăng ký.
  let teaser = null;
  function placeTeaser() {
    if (!teaser) return;
    let off = window.innerWidth >= 750 ? 24 : 16;
    const bar = document.querySelector('hb-sticky-buy');
    if (bar) {
      const r = bar.getBoundingClientRect();
      if (r.height > 0 && r.top < window.innerHeight - 1 && r.bottom > 0) off = Math.max(off, window.innerHeight - r.top + 10);
    }
    teaser.style.bottom = `calc(${Math.round(off)}px + env(safe-area-inset-bottom))`;
  }
  let placeQueued = false;
  const queuePlace = () => { if (placeQueued) return; placeQueued = true; requestAnimationFrame(() => { placeQueued = false; placeTeaser(); }); };
  function hideTeaser() {
    if (!teaser) return;
    window.removeEventListener('scroll', queuePlace);
    window.removeEventListener('resize', queuePlace);
    teaser.remove();
    teaser = null;
  }
  function showTeaser() {
    if (teaser || !C.teaser || getCookie('hb_pp_sub') === '1' || ss.get('hb_pp_teaser_off') === '1') return;
    const tt = document.getElementById('hb-pp-teaser-tpl');
    if (!tt) return;
    document.body.appendChild(tt.content.cloneNode(true));
    teaser = document.querySelector('[data-hb-pp-teaser]');
    if (!teaser) return;
    teaser.querySelector('[data-hb-pp-teaser-open]').addEventListener('click', () => {
      clarity('event', 'hb_pp_teaser_open');
      hideTeaser();
      open('teaser');
    });
    teaser.querySelector('[data-hb-pp-teaser-x]').addEventListener('click', () => {
      ss.set('hb_pp_teaser_off', '1');
      clarity('event', 'hb_pp_teaser_close');
      hideTeaser();
    });
    placeTeaser();
    window.addEventListener('scroll', queuePlace, { passive: true });
    window.addEventListener('resize', queuePlace);
    requestAnimationFrame(() => requestAnimationFrame(() => teaser && teaser.classList.add('is-in')));
    clarity('event', 'hb_pp_teaser_show');
  }
  if (closedRecently) setTimeout(showTeaser, 1200);

  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  async function onSubmit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const input = form.querySelector('input[type="email"]');
    const err = form.querySelector('[data-hb-pp-err]');
    const btn = form.querySelector('button[type="submit"]');
    const email = (input.value || '').trim();
    if (!EMAIL.test(email)) {
      err.textContent = 'Please enter a valid email address.';
      input.focus();
      return;
    }
    err.textContent = '';
    btn.disabled = true;
    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'HB popup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                properties: { hb_popup_arm: arm, hb_popup_page: location.pathname },
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
              },
            },
          },
        },
        relationships: { list: { data: { type: 'list', id: C.list } } },
      },
    };
    try {
      const res = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(C.company)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2025-07-15' },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
    } catch (x) {
      btn.disabled = false;
      err.textContent = 'Something went wrong. Please try again.';
      return;
    }
    setCookie('hb_pp_sub', '1', 365);
    if (getCookie('hb_pp_bag') !== 'done') setCookie('hb_pp_bag', 'pending', 30);
    applyCode();
    clarity('event', 'hb_pp_submit');
    hideTeaser();
    if (bookInCart) Promise.resolve(maybeAddBag(true)).finally(tagCart); // mở lại từ nút nhắc khi giỏ đã có sách: túi vào ngay
    if (!root) return;
    root.dataset.step = 'ok';
    root.querySelectorAll('[data-hb-pp-step]').forEach((el) => { el.hidden = el.dataset.hbPpStep !== 'ok'; });
  }

  function copyCode(btn) {
    const code = C.code;
    const done = () => { btn.textContent = 'Copied'; };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, () => {});
    else done();
  }

})();
